import React from 'react';
import {useSelector} from "react-redux";
import {useTranslate} from "../../../system/useTranslate";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {DataView} from "primereact/dataview";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";

function GoalsListDialog({visible, onHide, value , onSelected, goalData}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const ItemTemplate = (data)=>{
        return(
            <div className="w-full p-1 text-xs">
                <div className="surface-50 border-round flex p-2 justify-content-between align-items-center">
                    <span>{data.title}</span>
                    {value?.id!==data.id?
                        <Button onClick={()=>{onSelected?.({updateData:{parentGoal:data.id}})}} pt={{label:()=>({className:"font-normal text-2xs"})}} className="text-xs border-1 p-button-success p-button-outlined px-2 p-1" label={translate("choose")}/>:
                        <Button onClick={()=>{onSelected?.({updateData:{parentGoal:null}})}} pt={{label:()=>({className:"font-normal text-2xs"})}} className="text-xs border-1 p-button-danger p-button-outlined px-2 p-1" label={translate("disconnect")}/>}
                </div>
            </div>
        )
    }
    return(
        <Dialog header={translate("choose-goal")} className="w-4 rtl" visible={visible} onHide={onHide}>
            <DataView emptyMessage={<DatatableEmptyMessage/>} layout="list" itemTemplate={ItemTemplate} value={workspaceMembershipData?.workspace.goals.filter(g=>g.id!==goalData?.id)}/>
        </Dialog>
    )
}

export default GoalsListDialog;